import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  ACTIONS_TASK_ARRAY,
  ACTION_CARD_EVENT,
  ACTION_CONFIGURATION,
  ACTION_EVENT,
  ACTION_TASK_CONSTANTS,
  COMPARISON_FILTERS,
  NEW_ACTION,
  NEW_ACTION_LABEL,
  SELECT_ACTION,
  SELECT_ACTION_ARRAY,
  SELECT_ACTION_ARRAY_MEDICAL_ORDER,
  SELECT_ACTION_ARRAY_TASK,
  USERS_TAG
} from "../../constants/ActionConstants";
import { FORM_VALIDATORS } from "@/shared/constants/FormConstants";
import Vuetify from "vuetify";

Vue.use(Vuetify);
@Component({
  name: "NewActionCard"
})
export default class NewActionCard extends Vue {
  @Prop() private mainFilter!: string;
  @Prop() private selectFormFlag!: boolean;
  @Prop({ default: "" }) private activateItem!: { [key: string]: string };

  selectedAction = "";
  isSendNotification = false;
  isDuplicated = false;
  isValid = false;

  selectActionArray: {
    [key: string]: string | boolean;
  }[] = SELECT_ACTION_ARRAY;
  activateItemObject = { ...this.activateItem };
  selectFlag = true;

  NEW_ACTION = NEW_ACTION;
  ACTION_CONFIGURATION = ACTION_CONFIGURATION;
  NEW_ACTION_BTN_LABEL = NEW_ACTION_LABEL.NEW_ACTION_BTN_LABEL;
  ACTION_SELECT = NEW_ACTION_LABEL.SELECT_CHOOSE_ACTION;
  MULTIPLE_NOTIFICATIONS_ALLOWED =
    NEW_ACTION_LABEL.MULTIPLE_NOTIFICATIONS_ALLOWED;

  cardClass = STYLE_CLASSES.CARD;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  btnClassPrimary = STYLE_CLASSES.PRIMARY_BTN;

  requiredField = [FORM_VALIDATORS.REQUIRED_FIELD];

  mounted() {
    this.cleaningSelectedItems();
    if (this.mainFilter === COMPARISON_FILTERS.MEDICAL_ORDERS) {
      this.selectActionArray = SELECT_ACTION_ARRAY_MEDICAL_ORDER;
    } else if (this.mainFilter === COMPARISON_FILTERS.FORMS) {
      if (this.selectFormFlag) {
        this.selectActionArray = [SELECT_ACTION_ARRAY[2]];
      } else {
        this.selectActionArray = [];
        this.selectFlag = false;
      }
    } else if (this.mainFilter === COMPARISON_FILTERS.TASKS) {
      this.selectActionArray = SELECT_ACTION_ARRAY_TASK;
    } else {
      if (this.activateItemObject.key) {
        SELECT_ACTION_ARRAY[2].active = true;
      } else if (this.mainFilter === COMPARISON_FILTERS.USERS) {
        SELECT_ACTION_ARRAY[2].active = true;
        SELECT_ACTION_ARRAY[3].active = true;
      }

      this.selectActionArray = SELECT_ACTION_ARRAY.filter(
        a => a.active === true
      );
      if (this.mainFilter === COMPARISON_FILTERS.SERVICES) {
        this.selectActionArray.push({
          title: SELECT_ACTION.CHANGE_STATE,
          value: ACTION_EVENT.CHANGE_STATE,
          active: true
        });
      }
    }
  }

  addItemActionSelect() {
    if (
      ![
        COMPARISON_FILTERS.FORMS,
        COMPARISON_FILTERS.MEDICAL_ORDERS,
        COMPARISON_FILTERS.TASKS
      ].includes(this.mainFilter)
    ) {
      if (this.activateItemObject.key) {
        SELECT_ACTION_ARRAY[2].active = true;
        this.selectActionArray = SELECT_ACTION_ARRAY.filter(
          action => action.active === true
        );
      }
    } else if (this.mainFilter === COMPARISON_FILTERS.MEDICAL_ORDERS) {
      SELECT_ACTION_ARRAY_MEDICAL_ORDER.forEach(a => {
        const comparisonString = this.activateItemObject.key
          ? this.activateItemObject.key
          : "None";
        if (a.title.includes(comparisonString.toLowerCase())) {
          a.active = true;
        }
      });
      this.selectActionArray = SELECT_ACTION_ARRAY_MEDICAL_ORDER.filter(
        action => action.active === true
      );
    } else if (this.mainFilter === COMPARISON_FILTERS.FORMS) {
      this.selectFlag = true;
      if (
        this.activateItemObject.key &&
        this.activateItemObject.key === USERS_TAG
      ) {
        this.selectActionArray = [SELECT_ACTION_ARRAY[2]];
      } else {
        this.selectFlag = false;
      }
    }
  }

  @Watch("activateItem")
  modifyActivatedItem() {
    this.activateItemObject = {
      key: (this.activateItem.key as unknown) as string
    };
    if (
      this.mainFilter === COMPARISON_FILTERS.FORMS &&
      this.activateItemObject.key === USERS_TAG
    )
      this.addItemActionSelect();
  }

  @Watch("selectedAction")
  actionSelected() {
    this.isSendNotification = this.selectedAction === ACTION_EVENT.NOTIFICATION;
    this.isDuplicated = false;
    this.$emit(ACTION_CARD_EVENT.IS_DUPLICATED, false);
  }

  processAction() {
    if (ACTIONS_TASK_ARRAY.includes(this.selectedAction)) {
      this.$emit(
        ACTION_TASK_CONSTANTS.EMMITS.HANDLE_TASK_ACTIONS,
        this.selectedAction
      );
      return;
    }
    switch (this.selectedAction) {
      case ACTION_EVENT.TASK:
        this.$emit(ACTION_EVENT.TASK);
        break;
      case ACTION_EVENT.NOTIFICATION:
        this.$emit(ACTION_EVENT.NOTIFICATION);
        break;
      case ACTION_EVENT.DATA:
        this.$emit(ACTION_EVENT.DATA);
        break;
      case ACTION_EVENT.MEDICAL_ORDER:
        this.$emit(ACTION_EVENT.MEDICAL_ORDER);
        break;
      case ACTION_EVENT.CRATE_MEDICAL_ORDER:
        this.$emit(ACTION_EVENT.CRATE_MEDICAL_ORDER);
        break;
      case ACTION_EVENT.CHANGE_STATE:
        this.$emit(ACTION_EVENT.CHANGE_STATE);
        break;
    }
  }

  cleaningSelectedItems() {
    if (this.mainFilter === COMPARISON_FILTERS.MEDICAL_ORDERS) {
      SELECT_ACTION_ARRAY_MEDICAL_ORDER[2].active = false;
      this.selectActionArray = SELECT_ACTION_ARRAY_MEDICAL_ORDER;
    } else {
      SELECT_ACTION_ARRAY[2].active = false;
      this.selectActionArray = SELECT_ACTION_ARRAY;
    }
  }

  @Watch("isDuplicated")
  changedDuplicated() {
    this.$emit(ACTION_CARD_EVENT.IS_DUPLICATED, this.isDuplicated);
  }
}
